<template>
  <h1>Reset password</h1>
  <div>
    <form @submit.prevent="resetPassword">
      <div class="form-group mb-3">
        <label for="email" class="form-label">Email address</label>
        <input type="email" class="form-control" id="email" placeholder="Enter your email address" ref="emailInput"
               required>
      </div>
      <div class="form-group mb-3">
        <button type="submit" class="btn btn-primary">Reset password</button>
      </div>
    </form>
    <div v-if="error" class="alert alert-danger mt-3">{{ error }}</div>
  </div>
</template>

<script>
import {API_BASE_URL} from '@/config'
import {getCSRFToken} from '@/store/auth'

export default {
  name: 'ResetPasswordPage',
  data() {
    return {
      error: null
    }
  },
  mounted() {
    this.$refs.emailInput.focus()
  },
  methods: {
    async resetPassword() {
      const provided_email = this.$refs.emailInput.value
      try {
        const response = await fetch(`${API_BASE_URL}/send-password-reset-link`, {
          method: "POST",
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCSRFToken()
          },
          body: JSON.stringify({email: provided_email}),
          credentials: 'include'
        })
        const data = await response.json()
        if (response.ok) {
          this.success = 'Password reset email has been sent to your email address.'
          this.$router.push({path: '/', query: {success: this.success}})
        } else {
          this.error = data.error || 'An error occurred during password reset.'
        }
      } catch (err) {
        this.error = 'An error occurred during password reset: ' + err
      }
    }
  }
}

</script>